module.exports = __webpack_public_path__ + "static/2-additional-work-d8fe80887fc2f31388e64346af99915e.svg";